export default function Linkedin({
	onClick,
	id: buttonId,
	value,
	type,
	isCompany,
	socialData,
	children,
}) {
	if (!value || !value.length) {
		return false;
	}

	function doOnClick(e) {
		onClick(e, buttonId);
	}

	const url =
		(socialData.domain ? socialData.domain : '') + ('1' === isCompany ? 'company/' : 'in/') + value;

	return (
		<a onClick={doOnClick} href={url} className="btn">
			{children}
		</a>
	);
}
